export default __webpack_public_path__ + "static/media/head01_zh_cn_pc@2x.a9cbc438.png";